import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import Testimonial from 'src/entities/Testimonial';
import { getTestimonial, GetTestimonialAction } from 'src/actions/testimonial/get/GetTestimonial.actions';
import TestimonialComponent from 'src/modules/testimonial/Testimonial.component';

interface StateProps {
  testimonial?: Testimonial;
}

interface DispatchProps {
  getTestimonial: () => Promise<GetTestimonialAction>;
}

interface Props extends StateProps, DispatchProps {
}

class TestimonialContainer extends React.Component<Props> {

  public componentWillMount(): void {
    this.props.getTestimonial();
  }

  public render(): React.ReactNode {
    return (
      this.props.testimonial ?
        <TestimonialComponent testimonial={this.props.testimonial}/> :
        null
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  getTestimonial: (): Promise<GetTestimonialAction> => (
    dispatch(getTestimonial())
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  testimonial: state.getTestimonial.testimonial
});

export default connect(mapStateToProps, mapDispatchToProps)(TestimonialContainer);


// WEBPACK FOOTER //
// ./src/modules/testimonial/Testimonial.container.tsx